import React from 'react';
import MasterclassIndex from 'pages/masterclass';

export default function () {
  return <MasterclassIndex noFixedVideo noExitIntent noFixedSocial variant="ad" />;
}
